import { defaultListMessages, ListMessages } from "../shared/crud/list";
import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "tagsManager.title",
    defaultMessage: "Tags management",
  },
  createTagsBtn: {
    id: "tagsManager.createTags",
    defaultMessage: "Create tags by excel",
  },
  edit: {
    id: "tagsManager.edit",
    defaultMessage: "Edit",
  },
  typeProperty: {
    id: "tagsManager.type.property",
    defaultMessage: "Property",
  },
  typeAccommodation: {
    id: "tagsManager.type.accommodation",
    defaultMessage: "Accommodation",
  },
  typePackage: {
    id: "tagsManager.type.packages",
    defaultMessage: "Package",
  },
  typeExtra: {
    id: "tagsManager.type.extra",
    defaultMessage: "Extra",
  },
});

export const listMessages: ListMessages = {
  ...defaultListMessages,
  entityName: {
    id: "tagsManager.title",
    defaultMessage: "Tags management",
  },
  tableHeaders: {
    ticker: {
      id: "tagsManager.table.id",
      defaultMessage: "Id",
    },
    translations: {
      id: "tagsManager.table.name",
      defaultMessage: "Name",
    },
    type: {
      id: "tagsManager.table.type",
      defaultMessage: "Type",
    },
    tags: {
      id: "tagsManager.table.tags",
      defaultMessage: "Tags",
    },
  },
};
